export enum ClassificationFlow {
  EU = 'eu',
  US = 'us',
  UK = 'uk',
}

export enum LpInvestorClassificationStage {
  EULegalEntityCategorisation = 'eu-legal-entity-categorisation',
  EULegalEntityExperience = 'eu-legal-entity-experience',
  EULegalEntityKnowledge = 'eu-legal-entity-knowledge',
  UKLegalEntityCategorisation = 'uk-legal-entity-categorisation',
  UKLegalEntityWarning = 'uk-legal-entity-warning',
  UKLegalEntityExperience = 'uk-legal-entity-experience',
  UKLegalEntityKnowledge = 'uk-legal-entity-knowledge',
  USLegalEntityAccreditedInvestor = 'us-legal-entity-accredited-investor',
  USLegalEntityQualifiedPurchaser = 'us-legal-entity-qualified-purchaser',
  USLegalEntityQualifiedClient = 'us-legal-entity-qualified-client',
  USLegalEntityExperience = 'us-legal-entity-experience',
  USLegalEntityKnowledge = 'us-legal-entity-knowledge',
  EUIndividualExperience = 'eu-individual-experience',
  EUIndividualKnowledge = 'eu-individual-knowledge',
  UKIndividualSophisticatedInvestorStatement = 'uk-individual-sophisticated-investor-statement',
  UKIndividualHighNetWorthInvestorStatement = 'uk-individual-high-net-worth-investor-statement',
  UKIndividualProfessionalClientStatement = 'uk-individual-professional-client-statement',
  UKIndividualExperience = 'uk-individual-experience',
  UKIndividualKnowledge = 'uk-individual-knowledge',
  USIndividualAccreditedInvestor = 'us-individual-accredited-investor',
  USIndividualQualifiedPurchaser = 'us-individual-qualified-purchaser',
  USIndividualQualifiedClient = 'us-individual-qualified-client',
  USIndividualExperience = 'us-individual-experience',
  USIndividualKnowledge = 'us-individual-knowledge',
}

export enum LpInvestorClassification {
  UKHighNetWorthInvestor = 'uk-high-net-worth-investor',
  UKSophisticatedInvestor = 'uk-sophisticated-investor',
  UKProfessionalClient = 'uk-professional-client',
  EUElectiveProfessionalClient = 'eu-elective-professional-client',
  USAccreditedInvestor = 'us-accredited-investor',
  USQualifiedPurchaser = 'us-qualified-purchaser',
  USQualifiedClient = 'us-qualified-client',
}
